/* unplugin-vue-components disabled */import { render } from "./newsmain.vue?vue&type=template&id=2c8d9320&scoped=true"
import script from "./newsmain.vue?vue&type=script&lang=js"
export * from "./newsmain.vue?vue&type=script&lang=js"

import "./newsmain.vue?vue&type=style&index=0&id=2c8d9320&scoped=true&lang=css"

import exportComponent from "D:\\PPPPPPPPPPPPPPPPPPPPPPPPPPPPPPP\\官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c8d9320"]])

export default __exports__